/**
 * Vue Router guard: `requireAddNewOrderEnabled(redirectTo)` (card #645).
 *
 * The distributor Add New Order page is closed unless the SuperAdmin switch
 * `add_new_order_enabled` is ON (default OFF). The guard WAITS for a fresh
 * read of the switch before deciding, and fails CLOSED: a failed or malformed
 * read counts as OFF, so the visitor lands on `redirectTo` (the Orders list).
 *
 * Chain it AFTER `requireCapability(...)` so a caller who may not place orders
 * at all is bounced before the switch is even read.
 */
import { refreshAddNewOrderEnabled } from '@/composables/useAddNewOrderEnabled'

export function requireAddNewOrderEnabled(redirectTo) {
    return async (to, from, next) => {
        const enabled = await refreshAddNewOrderEnabled()
        return enabled === true ? next() : next(redirectTo)
    }
}
